import { useHistory } from "react-router-dom";
import { useContext, useEffect } from "react";
import { ToolContext } from "../../core/context/ToolContext";
import { rqx } from "../../core/request/API";
import { env } from "../../core/Env";

export const Index = () => {
    const { tool_state, personalization_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { walkthrough } = personalization_state

    const history = useHistory();
    const url = window.location.pathname
    const location = url.split('/')[2]

    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
    const tool_id = process.env.REACT_APP_TID_PSL;

    useEffect(() => {
         const __checkOnboarding = async () => {
            let data = await rqx.get(`<<global>>/${env()}/personalization/read`,{ tool_id: tool_id, user_id: user_id, ref: 'onboarding' });
            
            if (data.length > 0) {
                const p = JSON.parse(data[0].personalization);
                const onboarding = p.find(x => x.sf_name === "onboading");
                const general = p.find(x => x.sf_name === "general");

                if (onboarding?.status === 0) {
                    history.push("/psl/onboarding")
                } else if(general?.status === 0) {
                    if (location === 'publication') {
                        walkthrough.set(prev => ({ ...prev, general: true }));
                    } else {
                        history.push("/psl/publication?tab=article")
                        setTimeout(() => {
                            walkthrough.set(prev => ({ ...prev, general: true }));
                        }, 300);
                    }
                } else {
                    history.push("/psl/publication?tab=article")
                }
            } else {
                history.push("/psl/onboarding")
            }
        };
        __checkOnboarding()
        // eslint-disable-next-line
    }, []);

    return null;
};
